import { useCallback, useEffect, useState } from 'react';

const useElementVisible = options => {
  const [node, setNode] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const containerRef = useCallback(domNode => {
    setNode(domNode);
  }, []);

  useEffect(() => {
    if (!node) return undefined;

    // eslint-disable-next-line no-undef
    const observer = new IntersectionObserver(entries => {
      const [entry] = entries;
      setIsVisible(entry.isIntersecting);
    }, options);

    observer.observe(node);

    return () => {
      observer.unobserve(node);
      observer.disconnect();
    };
  }, [node, options]);

  return [containerRef, isVisible];
};

export default useElementVisible;
